import {AxiosService} from './axiosService';

export class SiteHealthService extends AxiosService {
  async getSiteHealth(groupId, statusDateTime = null) {
    try {
      let url = `/sitehealth/${groupId}`;
      const params = new URLSearchParams();
      params.append('GroupId', groupId);

      if (statusDateTime) {
        params.append('StatusDateTime', statusDateTime);
      }
      url += '?' + params.toString();

      const {data} = await this.axios.get(url);

      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      console.log({e});
      if (e?.response?.status !== 401) {
        return {
          status: 'FAILURE',
          errors: e?.response?.data?.errors,
        };
      }
    }
  }

  async getEquipmentData(equipmentId, statusDateTime = null) {
    try {
      let url = `/sitehealth/equipmentData`;
      const params = new URLSearchParams();
      params.append('EquipmentId', equipmentId);

      if (statusDateTime) {
        params.append('StatusDateTime', statusDateTime);
      }
      url += '?' + params.toString();

      const {data} = await this.axios.get(url);

      return data;
    } catch (e) {
      // if the status code is a 401 we do NOT want to throw
      if (e?.response?.status !== 401) {
        throw e;
      }
    }
    return null;
  }
}

export const siteHealthService = new SiteHealthService();
